// @flow
import * as React from 'react';

/**
 * Renders the cover image for the board with the dimensions dim (since it's
 * going to be a square). Cover images are returned from the API in a different
 * format from the array of images, so it needs to be handled separately.
 *
 * In the case that the cover image has been modified, we'll be given the imgUrl's
 * width, height, and starting x, y coordinates.
 *
 */
export default function BoardCoverImage({
  customCover,
  height,
  imgUrl,
  imgPos,
  width,
}: {
  customCover?: boolean,
  height: number,
  imgPos?: {
    height: number,
    width: number,
    x: number,
    y: number,
  },
  imgUrl: string,
  width: number,
}) {
  const wrapperStyle = {
    height,
    width,
  };
  const containerAspect = height / width;
  let backgroundPosition = 'center center';
  if (customCover && imgPos) {
    // need to calculate the scaling.
    let imgScale = 1;
    if (imgPos.height / imgPos.width > containerAspect) {
      // if image is taller than necessary
      imgScale = width / imgPos.width;
    } else {
      // if image is wider than necessary
      imgScale = height / imgPos.height;
    }

    const x = imgPos.x * imgScale;
    const y = imgPos.y * imgScale;
    backgroundPosition = `-${x}px -${y}px`;
  }

  const coverStyle = {
    backgroundImage: `url(${imgUrl})`,
    backgroundPosition,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    minHeight: '100%',
    backgroundColor: '#EFEFEF',
  };

  return (
    <div style={wrapperStyle}>
      <div className="relative" style={coverStyle}>
        <div className="imageWash absolute" />
      </div>
    </div>
  );
}
